module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "fs",
    attrs: {
      "id": "page020"
    }
  }, [_c('div', {
    staticClass: "jstfy",
    attrs: {
      "id": "page020_1"
    }
  }, [_vm._v("AÏOLI")]), _vm._v(" "), _c('div', {
    staticClass: "jstfy",
    attrs: {
      "id": "page020_2"
    }
  }, [_vm._v("TIME REQUIRED:")]), _vm._v(" "), _c('div', {
    staticClass: "jstfy",
    attrs: {
      "id": "page020_3"
    }
  }, [_vm._v("A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ïoli hails from")]), _vm._v(" Marseille. A grand aïoli is a feast and social")]), _vm._v(" "), _c('div', {
    staticClass: "jstfy",
    attrs: {
      "id": "page020_4"
    }
  }, [_vm._v("10 minutes")]), _vm._v(" "), _c('div', {
    staticClass: "jstfy",
    attrs: {
      "id": "page020_5"
    }
  }, [_vm._v("occasion to be shared by family and friends.")]), _vm._v(" "), _c('div', {
    staticClass: "jstfy",
    attrs: {
      "id": "page020_6"
    }
  }, [_vm._v("80 g white sandwich")]), _vm._v(" "), _c('div', {
    staticClass: "jstfy",
    attrs: {
      "id": "page020_7"
    }
  }, [_vm._v("1.")]), _vm._v(" "), _c('div', {
    staticClass: "jstfy",
    attrs: {
      "id": "page020_7a"
    }
  }, [_c('span', {
    staticClass: "page020_7a"
  }, [_vm._v(" Squeeze the bread, break it into small pieces and put it into a")])]), _vm._v(" "), _c('div', {
    staticClass: "jstfy",
    attrs: {
      "id": "page020_8"
    }
  }, [_vm._v("bread, crust removed")]), _vm._v(" "), _c('div', {
    staticClass: "jstfy",
    attrs: {
      "id": "page020_9"
    }
  }, [_vm._v("blending beaker. Peel and coarsely chop the garlic and add it to")]), _vm._v(" "), _c('div', {
    staticClass: "jstfy",
    attrs: {
      "id": "page020_10"
    }
  }, [_vm._v("and soaked in a little")]), _vm._v(" "), _c('div', {
    staticClass: "jstfy",
    attrs: {
      "id": "page020_11"
    }
  }, [_vm._v("the bread.")]), _vm._v(" "), _c('div', {
    staticClass: "jstfy",
    attrs: {
      "id": "page020_12"
    }
  }, [_vm._v("2.")]), _vm._v(" "), _c('div', {
    staticClass: "jstfy",
    attrs: {
      "id": "page020_12a"
    }
  }, [_c('span', {
    staticClass: "page020_12a"
  }, [_vm._v(" Use a hand-held blender to incorporate the oil, first a drop at")])]), _vm._v(" "), _c('div', {
    staticClass: "jstfy",
    attrs: {
      "id": "page020_13"
    }
  }, [_vm._v("water")]), _vm._v(" "), _c('div', {
    staticClass: "jstfy",
    attrs: {
      "id": "page020_14"
    }
  }, [_vm._v("a time and then in a stream. If the aïoli is too thick, thin it with a")]), _vm._v(" "), _c('div', {
    staticClass: "jstfy",
    attrs: {
      "id": "page020_15"
    }
  }, [_vm._v("200 ml extra-virgin olive")]), _vm._v(" "), _c('div', {
    staticClass: "jstfy",
    attrs: {
      "id": "page020_16"
    }
  }, [_vm._v("little soya yoghurt.")]), _vm._v(" "), _c('div', {
    staticClass: "jstfy",
    attrs: {
      "id": "page020_17"
    }
  }, [_vm._v("oil")]), _vm._v(" "), _c('div', {
    staticClass: "jstfy",
    attrs: {
      "id": "page020_18"
    }
  }, [_vm._v("6 cloves garlic")]), _vm._v(" "), _c('div', {
    staticClass: "jstfy",
    attrs: {
      "id": "page020_19"
    }
  }, [_vm._v("Salt, pepper")]), _vm._v(" "), _c('div', {
    staticClass: "jstfy",
    attrs: {
      "id": "page020_20"
    }
  }, [_vm._v("B"), _c('span', {
    staticClass: "pagen"
  }, [_vm._v("asics")])]), _vm._v(" "), _c('div', {
    staticClass: "jstfy",
    attrs: {
      "id": "page020_0"
    }
  }, [_vm._v("20")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-601772b0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/page_020.vue
// module id = 114
// module chunks = 0